import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
    height: ${props => props.size || '100%'};
    width: ${props => props.size || 'auto'};
    border-radius: 50%;
    object-fit: cover;
    display: block;
    border: 2px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
`;

const Avatar = ({ src, alt = "User Avatar", size }) => {
    return (
        <Image src={src} alt={alt} size={size} />
    );
};

export default Avatar;
